import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import About from './Pages/About/About';
import Blogs from './Pages/Blogs/Blogs';
import CheckOut from './Pages/CheckOut/CheckOut';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import ServiceDetails from './Pages/ServiceDetails/ServiceDetails';
import SignUp from './Pages/SignUp/SignUp';
import Footer from './Shared/Footer/Footer';
import Header from "./Shared/Header/Header";
import RequireAuth from './Shared/RequireAuth/RequireAuth';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from './Pages/NotFound/NotFound';
function App() {
  return (
    <>
      <Header/>
      <main style={{marginTop : '100px'}}>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/home' element={<Home/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/services/:serviceId' element={<ServiceDetails/>}/>
          <Route path="/checkOut" element={
            <RequireAuth>
              <CheckOut/>
            </RequireAuth>
          }></Route>
          <Route path='/blogs' element={<Blogs/>}/>
          <Route path='/blog' element={<Blogs/>}/>
          <Route path='/blog/:blogId' element={<ServiceDetails/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path='/sign-up' element={<SignUp/>}/>
          <Route path='*' element={<NotFound/>}/>
        </Routes>
      </main>
      <Footer/>
    </>
  );
}

export default App;
